// Reconstructed from the supplied production build; original component names were unavailable.
import {
  CalendarIcon,
  CreditCardIcon,
  FileTextIcon,
  PackageIcon,
  PercentIcon,
  React,
  RefreshCwIcon,
  SaveIcon,
  SearchIcon,
  SquarePenIcon,
  Trash2Icon,
  TrendingUpIcon,
  TriangleAlertIcon,
  UserIcon,
  UserPlusIcon,
  XIcon,
  motion,
  useNavigate,
} from "../vendor/runtime.js";
import { api } from "../services/api.js";
const AgentsPage = () => {
  const [e, t] = React.useState([]),
    [n, r] = React.useState([]),
    [a, l] = React.useState(true),
    [c, d] = React.useState(null),
    [f, h] = React.useState(""),
    [p, g] = React.useState(null),
    [y, v] = React.useState({}),
    [j, N] = React.useState(null),
    [b, S] = React.useState(false),
    O = useNavigate();
  (React.useEffect(() => {
    _();
  }, []),
    React.useEffect(() => {
      C();
    }, [f, e]));
  const _ = async () => {
      try {
        l(true);
        const q = await api.get("/admin/agents");
        t(q.data);
      } catch (q) {
        (console.error("Error fetching agents:", q),
          d("Failed to load agents. Please try again later."));
      } finally {
        l(false);
      }
    },
    C = () => {
      if (!f) {
        r(e);
        return;
      }
      const q = e.filter((z) => {
        var Y, F;
        return (
          ((Y = z.name) == null ? undefined : Y.toLowerCase().includes(f.toLowerCase())) ||
          ((F = z.id) == null ? undefined : F.toLowerCase().includes(f.toLowerCase()))
        );
      });
      r(q);
    },
    A = (q, z) => {
      (z.stopPropagation(),
        g(q.id),
        v({
          name: q.name || "",
          password: "",
          commissionRate: q.commissionRate || 0,
        }));
    },
    T = () => {
      (g(null), v({}));
    },
    M = async (q) => {
      try {
        S(true);
        const z = parseFloat(y.commissionRate);
        if (isNaN(z) || z < 0 || z > 1) {
          d("Commission rate must be between 0.0 and 1.0");
          return;
        }
        const Y = {
          name: y.name,
          commissionRate: z,
        };
        y.password.trim() && (Y.password = y.password);
        const F = await api.put(`/admin/agents/${q}`, Y);
        (t((B) =>
          B.map((K) =>
            K.id === q
              ? {
                  ...K,
                  name: y.name,
                  commissionRate: z,
                  updated_at: new Date().toISOString(),
                }
              : K,
          ),
        ),
          g(null),
          v({}),
          d(null),
          console.log("Update successful:", F.data.message));
      } catch (z) {
        (console.error("Error updating agent:", z), d("Failed to update agent. Please try again."));
      } finally {
        S(false);
      }
    },
    k = (q, z) => {
      (z.stopPropagation(), N(q));
    },
    $ = async () => {
      try {
        (S(true),
          await api.delete(`/admin/agents/${j.id}`),
          t((q) => q.filter((z) => z.id !== j.id)),
          N(null),
          d(null));
      } catch (q) {
        (console.error("Error deleting agent:", q), d("Failed to delete agent. Please try again."));
      } finally {
        S(false);
      }
    },
    I = (q, z) => {
      v((Y) => ({
        ...Y,
        [q]: z,
      }));
    },
    U = {
      hidden: {
        opacity: 0,
        y: 20,
      },
      visible: {
        opacity: 1,
        y: 0,
        transition: {
          duration: 0.4,
        },
      },
    };
  return a && e.length === 0 ? (
    <div className={"admin-page bg-gradient-to-br from-purple-50 to-purple-100"}>
      <div className={"flex items-center justify-center h-screen"}>
        <div className={"p-8 flex flex-col items-center"}>
          <div className={"w-16 h-16 relative"}>
            <div
              className={
                "absolute inset-0 rounded-full border-t-4 border-b-4 border-purple-600 animate-spin"
              }
            />
            <div
              className={
                "absolute inset-0 rounded-full border-r-4 border-l-4 border-purple-700 animate-pulse opacity-75"
              }
            />
          </div>
          <p className={"mt-4 text-gray-600"}>{"Loading agents..."}</p>
        </div>
      </div>
    </div>
  ) : (
    <div className={"admin-page bg-gradient-to-br from-purple-50 to-purple-100"}>
      <main className="admin-main">
        <motion.div initial={"hidden"} animate={"visible"} variants={U} className={"mb-8"}>
          <h1 className={"text-3xl font-bold text-gray-900 mb-2"}>{"Agents Management"}</h1>
          <p className={"text-gray-600"}>{"Manage and monitor agent accounts"}</p>
        </motion.div>
        {c && (
          <motion.div initial={"hidden"} animate={"visible"} variants={U} className={"mb-6"}>
            <div
              className={"bg-red-100 border-l-4 border-red-500 text-red-700 p-4 rounded-md"}
              role={"alert"}
            >
              <p className={"font-medium"}>{"Error"}</p>
              <p>{c}</p>
            </div>
          </motion.div>
        )}
        <motion.div initial={"hidden"} animate={"visible"} variants={U} className={"mb-6"}>
          <div
            className={
              "flex flex-col md:flex-row justify-between items-center gap-4 bg-white p-4 rounded-xl shadow-sm"
            }
          >
            <div className={"w-full md:w-1/3"}>
              <div className={"relative"}>
                <div
                  className={"absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"}
                >
                  <SearchIcon className={"h-5 w-5 text-gray-400"} />
                </div>
                <input
                  type={"text"}
                  placeholder={"Search by name or ID"}
                  className={
                    "pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-purple-500 focus:border-purple-500 block w-full"
                  }
                  value={f}
                  onChange={(q) => h(q.target.value)}
                />
              </div>
            </div>
            <div className={"flex flex-col sm:flex-row gap-3"}>
              <button
                onClick={() => O("/admin/register-agent")}
                className={
                  "px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 flex items-center"
                }
              >
                <UserPlusIcon className={"h-5 w-5 mr-2"} />
                {"Register New Agent"}
              </button>
              <button
                onClick={_}
                className={
                  "px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 flex items-center"
                }
                disabled={a}
              >
                <RefreshCwIcon className={`h-5 w-5 mr-2 ${a ? "animate-spin" : ""}`} />
                {"Refresh"}
              </button>
            </div>
          </div>
        </motion.div>
        <motion.div initial={"hidden"} animate={"visible"} variants={U}>
          {n.length > 0 ? (
            <div className={"grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6"}>
              {n.map((q) => (
                <div
                  key={q.id || Math.random().toString()}
                  className={
                    "bg-white rounded-xl shadow-md overflow-hidden hover:shadow-lg transition-shadow"
                  }
                >
                  {p === q.id ? (
                    <div className={"p-6"}>
                      <div className={"flex items-center justify-between mb-4"}>
                        <h3 className={"text-lg font-semibold text-gray-800"}>{"Edit Agent"}</h3>
                        <button onClick={T} className={"text-gray-500 hover:text-gray-700"}>
                          <XIcon className={"h-5 w-5"} />
                        </button>
                      </div>
                      <div className={"space-y-4"}>
                        <div>
                          <label className={"block text-sm font-medium text-gray-700 mb-1"}>
                            {"Name"}
                          </label>
                          <input
                            type={"text"}
                            value={y.name}
                            onChange={(z) => I("name", z.target.value)}
                            className={
                              "w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-purple-500 focus:border-purple-500"
                            }
                            required={true}
                          />
                        </div>
                        <div>
                          <label className={"block text-sm font-medium text-gray-700 mb-1"}>
                            {"New Password"}
                            <span className={"text-gray-400 text-xs"}>{"(optional)"}</span>
                          </label>
                          <input
                            type={"password"}
                            value={y.password}
                            onChange={(z) => I("password", z.target.value)}
                            className={
                              "w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-purple-500 focus:border-purple-500"
                            }
                            placeholder={"Leave blank to keep current password"}
                          />
                        </div>
                        <div className={"flex justify-end space-x-2 pt-4"}>
                          <button
                            onClick={T}
                            className={
                              "px-4 py-2 text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-50"
                            }
                            disabled={b}
                          >
                            {"Cancel"}
                          </button>
                          <button
                            onClick={() => M(q.id)}
                            className={
                              "px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 flex items-center"
                            }
                            disabled={b}
                          >
                            {b ? (
                              <RefreshCwIcon className={"h-4 w-4 mr-2 animate-spin"} />
                            ) : (
                              <SaveIcon className={"h-4 w-4 mr-2"} />
                            )}
                            {"Save"}
                          </button>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div
                      className={"p-6 cursor-pointer"}
                      onClick={() => O(`/admin/agents/${q.id}`)}
                    >
                      <div className={"flex items-center justify-between mb-4"}>
                        <div className={"flex items-center"}>
                          <div
                            className={
                              "flex-shrink-0 h-12 w-12 bg-purple-100 rounded-full flex items-center justify-center text-purple-600"
                            }
                          >
                            <UserIcon className={"h-6 w-6"} />
                          </div>
                          <div className={"ml-4"}>
                            <h3 className={"text-lg font-semibold text-gray-800"}>
                              {q.name || "Unnamed Agent"}
                            </h3>
                            <p className={"text-gray-500 text-sm"}>
                              {"ID: "}
                              {q.id || "No ID"}
                            </p>
                          </div>
                        </div>
                        <div className={"flex space-x-1"} onClick={(z) => z.stopPropagation()}>
                          <button
                            onClick={(z) => A(q, z)}
                            className={
                              "p-2 text-gray-500 hover:text-purple-600 hover:bg-purple-50 rounded-lg transition-colors"
                            }
                            title={"Edit agent"}
                          >
                            <SquarePenIcon className={"h-4 w-4"} />
                          </button>
                          <button
                            onClick={(z) => k(q, z)}
                            className={
                              "p-2 text-gray-500 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors"
                            }
                            title={"Delete agent"}
                          >
                            <Trash2Icon className={"h-4 w-4"} />
                          </button>
                        </div>
                      </div>
                      <div className={"mb-4 space-y-2"}>
                        <div className={"flex justify-between items-center"}>
                          <div className={"text-sm text-gray-500 flex items-center"}>
                            <CalendarIcon className={"h-4 w-4 mr-1"} />
                            {"Last Updated"}
                          </div>
                          <div className={"text-sm text-gray-600"}>
                            {q.updated_at ? new Date(q.updated_at).toLocaleDateString() : "N/A"}
                          </div>
                        </div>
                        <div className={"flex justify-between items-center"}>
                          <div className={"text-sm text-gray-500 flex items-center"}>
                            <CreditCardIcon className={"h-4 w-4 mr-1"} />
                            {"Wallet Balance"}
                          </div>
                          <div className={"text-sm text-gray-600 font-medium"}>
                            {"₹"}
                            {parseFloat(q.wallet_balance || 0).toLocaleString("en-IN", {
                              minimumFractionDigits: 2,
                            })}
                          </div>
                        </div>
                        <div className={"flex justify-between items-center"}>
                          <div className={"text-sm text-gray-500 flex items-center"}>
                            <PercentIcon className={"h-4 w-4 mr-1"} />
                            {"Commission Rate"}
                          </div>
                          <div className={"text-sm text-gray-600 font-medium"}>
                            {((q.commissionRate || 0) * 100).toFixed(1)}
                            {"%"}
                          </div>
                        </div>
                      </div>
                      <hr className={"my-4 border-gray-100"} />
                      <div className={"flex justify-between"}>
                        <div className={"flex items-center"}>
                          <PackageIcon className={"h-4 w-4 text-purple-500 mr-1"} />
                          <span className={"text-sm text-gray-600"}>{"Products"}</span>
                        </div>
                        <div className={"flex items-center"}>
                          <TrendingUpIcon className={"h-4 w-4 text-amber-500 mr-1"} />
                          <span className={"text-sm text-gray-600"}>{"Sales"}</span>
                        </div>
                        <div
                          className={
                            "flex items-center text-purple-500 text-sm font-medium hover:text-purple-600"
                          }
                        >
                          <FileTextIcon className={"h-4 w-4 mr-1"} />
                          {"View Details"}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          ) : (
            <div className={"bg-white rounded-2xl shadow-lg p-12 text-center"}>
              <div className={"flex flex-col items-center justify-center"}>
                <div
                  className={
                    "w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center text-gray-400 mb-6"
                  }
                >
                  <UserIcon className={"h-12 w-12"} />
                </div>
                <h3 className={"text-xl font-bold text-gray-800 mb-2"}>{"No Agents Found"}</h3>
                <p className={"text-gray-500 mb-6"}>
                  {f
                    ? "No agents match your search criteria."
                    : "There are no registered agents in the system yet."}
                </p>
                {f ? (
                  <button
                    onClick={() => h("")}
                    className={
                      "px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 flex items-center"
                    }
                  >
                    <RefreshCwIcon className={"h-5 w-5 mr-2"} />
                    {"Clear Search"}
                  </button>
                ) : (
                  <button
                    onClick={() => O("/admin/register-agent")}
                    className={
                      "px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 flex items-center"
                    }
                  >
                    <UserPlusIcon className={"h-5 w-5 mr-2"} />
                    {"Register New Agent"}
                  </button>
                )}
              </div>
            </div>
          )}
        </motion.div>
      </main>
      {j && (
        <div
          className={"fixed inset-0 bg-black/50 flex items-center justify-center z-50"}
        >
          <motion.div
            initial={{
              opacity: 0,
              scale: 0.95,
            }}
            animate={{
              opacity: 1,
              scale: 1,
            }}
            className={"bg-white rounded-lg p-6 max-w-md w-full mx-4"}
          >
            <div className={"flex items-center mb-4"}>
              <div className={"flex-shrink-0"}>
                <TriangleAlertIcon className={"h-6 w-6 text-red-600"} />
              </div>
              <div className={"ml-3"}>
                <h3 className={"text-lg font-medium text-gray-900"}>{"Delete Agent"}</h3>
              </div>
            </div>
            <div className={"mb-4"}>
              <p className={"text-gray-500"}>
                {"Are you sure you want to delete "}
                <strong>{j.name}</strong>
                {"? This action cannot be undone and will permanently remove all associated data."}
              </p>
            </div>
            <div className={"flex justify-end space-x-3"}>
              <button
                onClick={() => N(null)}
                className={
                  "px-4 py-2 text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-50"
                }
                disabled={b}
              >
                {"Cancel"}
              </button>
              <button
                onClick={$}
                className={
                  "px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 flex items-center"
                }
                disabled={b}
              >
                {b ? (
                  <RefreshCwIcon className={"h-4 w-4 mr-2 animate-spin"} />
                ) : (
                  <Trash2Icon className={"h-4 w-4 mr-2"} />
                )}
                {"Delete"}
              </button>
            </div>
          </motion.div>
        </div>
      )}
    </div>
  );
};
export { AgentsPage };
